import { useAuth } from "@/providers/auth";

export function LoadingPage({ children_factory }: { children_factory?: () => JSX.Element }) {
    const { loading } = useAuth();
    if (loading) {
        return (
            <div className="h-full w-full flex justify-center items-center">
                <div id="loader"></div>
            </div>
        );
    }
    return children_factory && children_factory();
}
